import React, { ReactNode } from 'react';

import { View } from 'react-native';


interface StyledControlsProps {
    colorsArray?: string[];
    opacityArray?: number[];
    radiusArray?: number[];
    child?: ReactNode;
    height: number,
}

export const StyledControls = ({colorsArray, opacityArray, radiusArray, child, height} : StyledControlsProps) => {
  const [renderChild, setRenderChild] = React.useState(true);

  React.useEffect(() => {
    if(colorsArray && opacityArray && radiusArray && colorsArray.length> 0 && opacityArray.length>0 && radiusArray.length>0) {
      setRenderChild(false);
    } else {
      setRenderChild(true);
    }
  }, []);

  if(renderChild) {
    return child;
  } else {
    const R = radiusArray[0]*height /2;
    return (<><View
      style={{
        backgroundColor: colorsArray[0],
        width: 2*R,
        height: 2*R,
        borderRadius: R,
        opacity: opacityArray[0],
        justifyContent:'center',
        alignItems: 'center'
      }}>
      <StyledControls
        colorsArray={colorsArray?.slice(1)}
        opacityArray={opacityArray?.slice(1)}
        radiusArray={radiusArray?.slice(1)}
        child={child}
        height={height}
      />
    </View>

    </>
    );
  }
};


